// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../../core/reducers';
// Selectors
import {
  selectQueryResult,
  selectAgreementTemplatesPageLoading,
  selectAgreementTemplatesShowInitWaitingMessage,
} from '../_selectors/agreement-template.selectors';

export class AgreementTemplatesDataSource extends BaseDataSource {
  items: any[];

  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectAgreementTemplatesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectAgreementTemplatesShowInitWaitingMessage),
    );

    this.store.pipe(select(selectQueryResult)).subscribe((response: QueryResultsModel) => {
      this.items = response.items;
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }

  setItems(items) {
    this.items = items;
    this.entitySubject.next(items);
  }

  filter(func) {
    this.items = this.items.filter(func);
    this.entitySubject.next(this.items);
  }
}
